import { api } from './api.js';
import { TAG_LEAD, TAG_LIST_LEADS } from './tags.js';
import { convertToUrlSearchParams } from '../utils/helper.js';

export const leadsEndpoints = api.injectEndpoints({
    endpoints: (builder) => ({
        getLeads: builder.query({
            query: (params) => {
                return {
                    url: `/leads?${convertToUrlSearchParams(params)}`,
                    method: 'GET'
                };
            },
            providesTags: [TAG_LIST_LEADS],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        getLead: builder.query({
            query: (id) => ({
                url: `/leads/view/${id}`,
                method: 'GET'
            }),
            providesTags: [TAG_LEAD],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        getLeadsStatuses: builder.query({
            query: () => ({
                url: '/misc/lead-statuses',
                method: 'GET'
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        editLead: builder.mutation({
            query: ({ id, data }) => ({
                url: `/leads/edit/${id}`,
                method: 'POST',
                body: data
            }),
            invalidatesTags: [TAG_LIST_LEADS, TAG_LEAD],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        })
    })
});

export const { useLazyGetLeadsQuery, useGetLeadQuery, useGetLeadsStatusesQuery, useEditLeadMutation } = leadsEndpoints;
